// @flow

import React from 'react';
import bemify from 'bemify-js';

import Icon from 'app/common/components/Icon';
import 'app/viewport/components/Header/HeaderSearchToggle.scss';

const bem = bemify('header-search-toggle');

type Props = {
  onClick: () => void,
};

const HeaderSearchToggle = ({ onClick }: Props) => {
  return (
    <button aria-label="Search apps" className={bem()} onClick={onClick}>
      <Icon className={bem('__icon')} type="search" />
    </button>
  );
};

export default HeaderSearchToggle;
